import Storage from '../../plugins/localForage'
import { Utile } from 'utils'
const _$localForage = new Storage()
const MutionsOfData = { // 监听随时变化 修改储存装置值
  'SET_USERNAME_DATA': 'member',
  'Mut_navlist': 'navlist',
  'remove_navlist': 'navlist',
  'SETTING_USER_PERMISSION': 'permission',
  'In_allgame': 'allGameList',
  'SET_GAMEID': 'gameid',
  'setExgame': 'ExgameList'
}
const localMutionsOfData = { // 初始化 从indeddb 拉值导入vuex
  'SET_USERNAME_DATA': 'member',
  'IN_navlist': 'navlist',
  'SETTING_USER_PERMISSION': 'permission',
  'In_allgame': 'allGameList',
  'SET_GAMEID': 'gameid',
  'setExgame': 'ExgameList'
}
const ofInterest = (mutation) => {
  return Object.keys(MutionsOfData).includes(mutation);
};
export default function persistencePlugin () {
  return store => {
    store._vm.$root.$data['vue-persist-patch-delay'] = true
    store.subscribe(async (mutation, state) => {
      if (ofInterest(mutation.type)) {
        const key = MutionsOfData[mutation.type]
        const data = Utile.dig(state, key)
        try {
          await _$localForage.setItem(key, data)
        } catch (error) {
          console.log('vuex localForage喷错辣-' + error);
        }
      } else if (mutation.type == 'initializestate') {
        try {
          const commitData = async function () {
            const it = await _$localForage.getItems()
            for (let obj in localMutionsOfData) {
              it[localMutionsOfData[obj]] ? store.commit(obj, it[localMutionsOfData[obj]]) : null
            }
          }
          const setdelay = async function () {
            store._vm.$root.$data['vue-persist-patch-delay'] = false
            store._vm.$root.$emit('storageReady')
          }
          await commitData()
          await setdelay()
        } catch (error) {
          console.log('store.commit喷错辣-' + error);
        }
      }
    })
  }
}